import * as basic from '../../../config/basic'

export const pm = {
  banner: {
    aiLogo: require('@/assets/transSave/resource/image/b8/67/b8bff540503a3dfd119f61e25bf67367.png'),
    mobileAiLogo: require('@/assets/transSave/resource/image/b8/67/b8bff540503a3dfd119f61e25bf67367.png'),
    titleCh: '产品经理赛道',
    titleEn: '',
    titleLogo: require('@/assets/transSave/resource/image/3b/9e/3bd2121ffb49200d7114c96336ee439e.png'),
    qrLeft: require('@/assets/transSave/resource/image/80/16/8040d55839dcfdab4291b2acfaa89d16.png'),
    // qrMiddle: require('@/assets/transSave/static/webank2023/webank-app-code.10161742.png'),
    qrMiddle: require('@/assets/transSave/static/webank2023/pm/img.png'),
    qrQt: require('@/assets/transSave/static/webank2023/pm/image41.png'),
    qrRight: require('@/assets/transSave/resource/image/09/2e/095525470af5707acdccdcfcffde7c2e.png'),
    mobileQrLeft: require('@/assets/transSave/resource/image/80/16/8040d55839dcfdab4291b2acfaa89d16.png'),
    mobileQrMiddle: require('@/assets/transSave/static/webank2023/webank-app-code.10161742.png'),
    mobileQrRight: require('@/assets/transSave/resource/image/09/2e/095525470af5707acdccdcfcffde7c2e.png'),
    caption: '微众银行 App',
    weChatAccounts: '微众银行 App 公众号',
    joinGroup: '微众银行 We2000',
    qtWe: '蜻蜓公众号',
  },
  train: {
    titleCh: '产品经理课程',
    titleEn: 'INIRODUCE',
    content: [
      {
        title: '',
        list: [
          {
            imgUrl: require('@/assets/transSave/static/webank2023/pm/lesson1.png'),
            title: '玩转钱包账户',
            text: '收银台进行支付（充值、提现、转账到卡），内部交易（转账到户）直接向交易系统下单。3. 核心流程 图4：钱包账户核心流程钱包账户是基于应用场景来流转的，它在用户使用过程中逐步的引导用户完成注册和实名认证。1）快速注册：为了快速的获',
            link: 'https://www.woshipm.com/pd/6078677.html'
          },
          {
            imgUrl: require('@/assets/transSave/static/webank2023/pm/lesson2.png'),
            title: '三张图搞懂账户设计',
            text: '你设计的账户产品能有良好的用户体验和优雅的扩展呢？这就是我今天要介绍的三户模型”。 三户模型是“客户、用户、账户”的简称，使用该方法设计出来的“账户”产品不管是设计和使用，都是非常舒适的。即使像“微信”、“支付宝”一样十几亿用户管理起',
            link: 'https://www.woshipm.com/pd/5946735.html'
          },
          {
            imgUrl: require('@/assets/transSave/static/webank2023/pm/lesson3.png'),
            title: '洞察 | 多邻国 用户激励体系设计',
            text: '400宝石。如果中间不小心断掉打卡，还可以用宝石来兑换“激冻卡”，妥妥的一个闭环。一旦用户参与挑战，则需要投入更多的时间和精力去学习，每个人都不愿意掉队，同时也为多邻国贡献了漂亮的活跃数据提升。 完成一个等级后，有机会限时获得',
            link: 'https://www.woshipm.com/share/6009286.html'
          },
          {
            imgUrl: require('@/assets/transSave/static/webank2023/pm/lesson4.png'),
            title: '用户激励体系搭建策略',
            text: '编辑导语：在产品运营中，用户激励体制是基本的激励方式，对用户有一定的指引、奖励等进行刺激；比如微博的每日签到领现金红包，保证了用户的每日留存；本文作者分享了关于用户激励体系搭建策略，我们一起来看一下。 一、为什么要做用户激',
            link: 'https://www.woshipm.com/operate/4281725.html'
          },
          {
            imgUrl: require('@/assets/transSave/static/webank2023/pm/lesson5.png'),
            title: '纯干货！如何利用激励体系提升用户粘性',
            text: '举措的讲述。 四、好看视频用户分层激励体系设计 1. 打造不同用户的激励动机 1）突出等级层级差异，强化平台精神激励 决定用户动机主要有8个核心的驱动力：使命',
            link: 'https://www.woshipm.com/pd/5847644.html'
          },
          {
            imgUrl: require('@/assets/transSave/static/webank2023/pm/lesson6.png'),
            title: '企业IP化操作指南',
            text: '什么是企业的IP化？ 首先要厘清的是，企业IP化不仅仅是指品牌IP化，这在当前的市场格局下远远不够。企业IP化其实可分为三大模块——产品IP、个人IP、品牌IP、 这三者共同组成了企业的IP化体系。也只有这样，才能在新时代的巨变中，发',
            link: 'https://www.woshipm.com/marketing/3944343.html'
          },
          {
            imgUrl: require('@/assets/transSave/static/webank2023/pm/lesson7.png'),
            title: '跟《动物餐厅》小游戏学习App游戏化设计',
            text: '编辑导读：很多产品为了让用户停留更久，会对界面做出一些游戏化的设计，让用户在一个个小游戏中忘却时间。而本文作者从一个爆款小游戏《动物餐厅》中获得灵感，谈谈如何学习它的游戏化设计，希望对你有帮助。 最近笔者和她的朋友们都疯狂',
            link: 'https://www.woshipm.com/pd/4568490.html'
          },
          {
            imgUrl: require('@/assets/transSave/static/webank2023/pm/lesson8.png'),
            title: '产品需要了解的游戏化设计',
            text: '编辑导读：为什么很多人沉迷于游戏？因为它的反馈非常及时，无论是正向的还是反向的，能一直吸引用户的注意力。如果将这些游戏化设计应用到普通的产品中，应该怎么做呢？ 现在很多的电商像淘宝的叠猫猫、盖楼、超级喵运会、芭芭农',
            link: 'https://www.woshipm.com/pd/5471542.html'
          }
        ],
      },
      {
        title: '培训视频'
      }
    ],
    list: [
      {
        imgUrl: require('@/assets/transSave/static/webank2023/pm/video1.png'),
        contentText: '产品经理能力模型（上）',
        video: 'https://www.bilibili.com/video/BV15h411b7AT/?spm_id_from=333.999.0.0'
      },
      {
        imgUrl: require('@/assets/transSave/static/webank2023/pm/video2.png'),
        contentText: '产品经理能力模型（下）',
        video: 'https://www.bilibili.com/video/BV1uY411s7Nm/?spm_id_from=333.788.recommend_more_video.0'
      },
      {
        imgUrl: require('@/assets/transSave/static/webank2023/pm/video3.png'),
        contentText: '深入浅出，用户成长体系详解（一）',
        video: 'https://www.bilibili.com/video/BV18V411E7pX/?spm_id_from=333.999.0.0'
      },
      {
        imgUrl: require('@/assets/transSave/static/webank2023/pm/video4.png'),
        contentText: '深入浅出，用户成长体系详解（二）',
        video: 'https://www.bilibili.com/video/BV1kV411E7Jc/?spm_id_from=333.999.0.0'
      },
      {
        imgUrl: require('@/assets/transSave/static/webank2023/pm/video5.png'),
        contentText: '如何塑造一款火遍全球的IP？【阿Test正经比比】',
        video: 'https://www.bilibili.com/video/BV1e54y1y7MX/?spm_id_from=333.337.search-card.all.click'
      },
      {
        imgUrl: require('@/assets/transSave/static/webank2023/pm/video6.png'),
        contentText: '拼多多的“Disney”体现在哪？深度剖析游戏化产品设计！硬核长篇',
        video: 'https://www.bilibili.com/video/BV1ZT411V7fW/?spm_id_from=333.337.search-card.all.click'
      }
    ]
  },
  wefinance: {
    titleCh: '微众银行财富+',
    titleEn: '',
    desc: '微众银行财富+致力于以买方视角的金融产品甄选、专业有温度的服务体验以及先进的金融科技与应用，基于微众银行 App，打造专业、安全、高效的一站式数字化财富管理服务，为用户精选各类产品，提供多元化资产配置选择。',
    content: {
      list: [
        {
          id: '01',
          logo: require('@/assets/transSave/resource/image/90/3e/906831399d4118ca3a9b82a67336763e.png'),
          title: '买方视角',
          desc: '从买方视角出发严选产品<br/>提供专业的财富管理服务'
        },
        {
          id: '02',
          logo: require('@/assets/transSave/resource/image/f8/ce/f88c92d605eb9ecda7b682bf80cd78ce.png'),
          title: '品类丰富',
          desc: '提供涵盖全市场多品类的<br/>优质金融产品'
        },
        {
          id: '03',
          logo: require('@/assets/transSave/resource/image/c9/ae/c9c39400c4b349e818bea7b9e5e347ae.png'),
          title: '金融科技',
          desc: '依托先进的金融科技<br/>提供丰富的数字产品及权益'
        },
        {
          id: '04',
          logo: require('@/assets/transSave/resource/image/b6/0f/b68d925cbdee9ac8f80c4e4edd63aa0f.png'),
          title: '暖心服务',
          desc: '提供无障碍和适老版专属理财服务<br/>消除“数字鸿沟”'
        }
      ]
    }
  },
  we2000: {
    titleCh: '微众银行 We2000',
    titleEn: '',
    desc: '微众银行We2000是微众银行财富+旗下面向年轻群体推出的，围绕日常生活消费而设计的一款集账户、理财、消费支付、积分权益等服务一体化的数字账户，倡导量入为出、聪明消费，有钱也要省着花的消费观念。',
    content: {
      list: [
        {
          id: '01',
          logo: require('@/assets/transSave/resource/image/41/2c/419b3f11c0ec1f955bae043fe445132c.png'),
          title: '年轻人都在用的数字账户',
          desc: '线上开通快速方便<br/>支持日常存钱和消费'
        },
        {
          id: '02',
          logo: require('@/assets/transSave/resource/image/73/fb/7364166b363d0645996yy6da07fbe8fb.png'),
          title: '便捷消费支付',
          desc: '绑定微信即可支付<br/>消费有优惠'
        },
        {
          id: '03',
          logo: require('@/assets/transSave/resource/image/ec/13/ec5e2cd6e244b1dccd7d02a2b5854213.png'),
          title: '闲钱管理好帮手',
          desc: '便捷零钱管理<br/>丰富理财知识课堂'
        }
      ]
    }
  },
  training: {
    list: [
      {
        imgUrl: require('@/assets/transSave/resource/image/1b/4c/1be30e544ea9798691777415ce60c84c.png'),
        contentText: '微众区块链 | 构筑 ESG 可信基础设施',
        video: 'https://mp.weixin.qq.com/s/CVta_0a3I6SMWX5YzYsCCw'
      },
      {
        imgUrl: require('@/assets/transSave/resource/image/01/d2/01d7ffd37e6f92486751b7101293yyd2.png'),
        contentText: 'FISCO BCOS 实操演示',
        video: 'https://v.qq.com/x/page/t3130e6wzh2.html'
      },
      {
        imgUrl: require('@/assets/transSave/resource/image/1c/ac/1c47652baf1daf231b70d60d73138aac.png'),
        contentText: '智能合约速成教程',
        video: 'https://v.qq.com/x/page/h3130tubdoz.html'
      },
      {
        imgUrl: require('@/assets/transSave/resource/image/b8/6f/b89909847bda44b30f7d2c18d68b186f.png'),
        contentText: 'FISCO BCOS 极速开发教程',
        video: 'https://mp.weixin.qq.com/s/-EquunJPW9BuXfP9dPI-bA'
      }
    ],
    buttonText: '查看更多开发教程',
    buttonLink: 'https://mp.weixin.qq.com/s/70FIPb-Acg1Fe0liotG3qg'
  },
  news: {
    titleCh: '新闻资讯',
    titleEn: 'INIRODUCE',
    content: {
      list: [
        {
          id: '01',
          idLogo: basic.one,
          idLogoMobile: basic.oneMobile,
          text: '《我在用微众银行》的感受是什么？安心、暖心、开心，诠释 “有温度的银行”',
          link: 'https://fund.stockstar.com/IG2022090900009248.shtml'
        },
        {
          id: '02',
          idLogo: basic.two,
          idLogoMobile: basic.twoMobile,
          text: '微众银行：2019年银行业用户体验大调研报告',
          link: 'https://mp.weixin.qq.com/s/zTnkd8NZJSu9bBw9bhUIWA'
        }
      ],
      moreLabel: '查看更多开发教程',
      moreLink: 'https://www.infoq.cn'
    }
  },
  bottom: {
    imgLeft: require('@/assets/transSave/resource/image/0d/09/0daf0bb0cfd240e4315c1865d6f85509.png'),
    textLeft: 'FISCO BCOS 开源社区',
    imgRight: require('@/assets/transSave/resource/image/58/19/5847ca05bc140fd25454cf19d358a819.png'),
    textRight: '微众区块链',
    qrGongzhonghao: '扫码关注公众号',
    qrText: '了解更多资讯',
  }
}
